module.exports = __webpack_public_path__ + "static/media/13.dd7f337a.jpg";